/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Ai_Chat_Jump_To_LatestInputs */

const en_admin_ai_chat_jump_to_latest = /** @type {(inputs: Admin_Ai_Chat_Jump_To_LatestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jump to latest`)
};

const de_admin_ai_chat_jump_to_latest = /** @type {(inputs: Admin_Ai_Chat_Jump_To_LatestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zum Ende springen`)
};

const es_admin_ai_chat_jump_to_latest = /** @type {(inputs: Admin_Ai_Chat_Jump_To_LatestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ir al más reciente`)
};

const fr_admin_ai_chat_jump_to_latest = /** @type {(inputs: Admin_Ai_Chat_Jump_To_LatestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aller au plus récent`)
};

const nl_admin_ai_chat_jump_to_latest = /** @type {(inputs: Admin_Ai_Chat_Jump_To_LatestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Naar nieuwste`)
};

/** @type {(inputs: Admin_Ai_Chat_Jump_To_LatestInputs) => LocalizedString} */
const it_admin_ai_chat_jump_to_latest = en_admin_ai_chat_jump_to_latest;

/** @type {(inputs: Admin_Ai_Chat_Jump_To_LatestInputs) => LocalizedString} */
const pt_br2_admin_ai_chat_jump_to_latest = en_admin_ai_chat_jump_to_latest;

/** @type {(inputs: Admin_Ai_Chat_Jump_To_LatestInputs) => LocalizedString} */
const pl_admin_ai_chat_jump_to_latest = en_admin_ai_chat_jump_to_latest;

/** @type {(inputs: Admin_Ai_Chat_Jump_To_LatestInputs) => LocalizedString} */
const hu_admin_ai_chat_jump_to_latest = en_admin_ai_chat_jump_to_latest;

/** @type {(inputs: Admin_Ai_Chat_Jump_To_LatestInputs) => LocalizedString} */
const ro_admin_ai_chat_jump_to_latest = en_admin_ai_chat_jump_to_latest;

/**
* | output |
* | --- |
* | "Jump to latest" |
*
* @param {Admin_Ai_Chat_Jump_To_LatestInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_ai_chat_jump_to_latest = /** @type {((inputs?: Admin_Ai_Chat_Jump_To_LatestInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Ai_Chat_Jump_To_LatestInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_ai_chat_jump_to_latest(inputs)
	if (locale === "de") return de_admin_ai_chat_jump_to_latest(inputs)
	if (locale === "es") return es_admin_ai_chat_jump_to_latest(inputs)
	if (locale === "fr") return fr_admin_ai_chat_jump_to_latest(inputs)
	if (locale === "nl") return nl_admin_ai_chat_jump_to_latest(inputs)
	if (locale === "it") return it_admin_ai_chat_jump_to_latest(inputs)
	if (locale === "pt-BR") return pt_br2_admin_ai_chat_jump_to_latest(inputs)
	if (locale === "pl") return pl_admin_ai_chat_jump_to_latest(inputs)
	if (locale === "hu") return hu_admin_ai_chat_jump_to_latest(inputs)
	return ro_admin_ai_chat_jump_to_latest(inputs)
});
export { admin_ai_chat_jump_to_latest as "admin.ai_chat.jump_to_latest" }